import React from "react";
import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import Nav from "./Nav/Nav";
import logo from "../assets/logo.png";
import { Link } from 'react-router-dom';

const Header = () => {
    const [navActive, setNavActive] = useState(false);
    return (
        <header className="absolute top-[40px] left-0 right-0 z-[60]">
            <div className="container mx-auto">
                <div className="flex flex-row justify-between items-center">
                    {/* logo */}
                    <a
                        href="/" 
                        className="relative w-[100px] h-[40px] xl:w-[120px] xl:h-[40px] z-[60]"
                    >
                        <img src={logo} alt="/" height={70}></img>
                    </a>
                    {/* <nav className="flex justify-end">
                        <ul className="navlinks flex-row justify-end flex-nowrap">
                            <li>
                                <Link to="/buceo">Buceo Profesional</Link>
                            </li>
                            <li>
                                <Link to="/robotica">Robótica Submarina</Link>
                            </li>
                            <li>
                                <Link to="/nosotros">Nosotros</Link>
                            </li>
                            <li>
                                <Link to="/clientes">Clientes</Link>
                            </li>
                            <li>
                                <Link to="/alianzas">Alianzas y Certificaciones</Link>
                            </li>
                            <li>
                                <Link to="/politica">Política de Calidad</Link>
                            </li>
                            <li>
                                <a href="http://www.frogmantienda.cl">Tienda</a>
                            </li>
                            <li>
                                <Link to="/contacto">Contacto</Link>
                            </li>
                            <li>
                                <Link to="/trabaja">Trabaja con Nosotros</Link>
                            </li>
                        </ul>
                    </nav> */}
                <div>
                    <button 
                        onClick={() => setNavActive(!navActive)} 
                        className="w-8 text-white relative flex items-center justify-center z-[60] outline-none"
                    >
                        <span 
                            className={`w-full h-[1.5px] bg-current absolute left-0 will-change-transform transition-transform duration-300 ${
                                navActive ? "top-1/2 rotate-45" : "top-0 translate-y-0"
                            }`}
                        ></span>
                        <span 
                            className={`w-full h-[1.5px] bg-current absolute left-0 transition-opacity duration-300 ${
                                navActive ? "opacity-0" : "top-1/2"
                            }`}
                        ></span>
                        <br/>
                        <span 
                            className={`w-full h-[1.5px] bg-current absolute left-0 will-change-transform transition-transform duration-300 ${
                                navActive ? "top-1/2 -rotate-45" : "bottom-0 translate-y-0"
                            }`}
                        ></span>
                    </button>
                </div>
                </div>
            </div>
            <AnimatePresence mode="wait">{navActive && <Nav />}</AnimatePresence>
        </header>
    );
};

export default Header;